import React, { useState, useCallback } from 'react';

interface KVProps {
  k: string;
  v: any;
  copy?: boolean;
}

function KV({ k, v, copy }: KVProps) {
  const display = v != null && v !== '' ? String(v) : '';
  const empty = !display || display === '—';

  return (
    <div className="sky-kv">
      <div className="sky-kv-label">{k}</div>
      <div className={`sky-kv-value ${empty ? 'sky-kv-value--empty' : ''}`}>
        <span className="sky-kv-text">{display || '—'}</span>
        {copy && !empty && <CopyIcon value={display} />}
      </div>
    </div>
  );
}

function CopyIcon({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard?.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1100);
  }, [value]);

  return (
    <button
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Copy'}
      className={`sky-copy-btn ${copied ? 'sky-copy-btn--done' : ''}`}
    >
      {copied ? (
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ) : (
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="9" y="9" width="13" height="13" rx="2" />
          <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
        </svg>
      )}
    </button>
  );
}

export default React.memo(KV);
